<template>
  <div class="checkout section fullscreen-content">
    <div
        class="notify fade"
        v-if="notification"
        :class="notification_type"
        @click="notification=false"
    >{{ notification }}
    </div>
    <div class="container">
      <div class="row">
        <div class="col-8 col-md-12 checkout-form">
          <div class="boxed-content cart-errors" v-if="cart_errors">
            <ul>
              <li v-for="(error, key) in cart_errors" :key="key">
                <router-link :to="$i18nRoute({name: 'product', params: {product: error.id}})">{{ error.name }}
                </router-link>
                - {{ error.msg }}
              </li>
            </ul>
          </div>
          <div class="boxed-content">
            <div class="row billing-address">
              <div class="col-12">
                <h2>{{ $t('shop.checkout.billing_address') }}</h2>
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.first_name')"
                    name="billing_first_name"
                    v-model="billing.first_name"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.last_name')"
                    name="billing_last_name"
                    v-model="billing.last_name"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.address')"
                    name="billing_address"
                    v-model="billing.address_1"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.address_1')"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input type="hidden" v-model="billing.country.name" @change="reset_state('billing')"/>
                <dropdown
                    :items="page.data.countries"
                    v-model="billing.country"
                ></dropdown>
              </div>
              <div class="col-6 col-md-12">
                <input type="hidden" v-model="billing.state"/>
                <dropdown
                    v-if="states.billing"
                    :items="states.billing"
                    v-model="billing_state"
                ></dropdown>
                <input
                    type="text"
                    v-else
                    :placeholder="$t('shop.checkout.state')"
                    v-model="billing.state"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.city')"
                    name="billing_city"
                    v-model="billing.city"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.zip')"
                    v-model="billing.zip_code"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.email')"
                    name="billing_email"
                    v-model="billing.email"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    :placeholder="$t('shop.checkout.phone')"
                    v-model="billing.phone"
                    @change="change"
                />
              </div>
              <div class="col-12">
                <textarea
                    :placeholder="$t('shop.checkout.comments')"
                    v-model="billing.comment"
                    @change="change"
                    cols="30"
                    rows="10"
                ></textarea>
              </div>
            </div>
            <div class="row ns ship-to-dif-address">
              <div class="col-12">
                <input
                    type="checkbox"
                    class="checkbox"
                    id="ship-to"
                    v-model="shipping.different"
                    @change="change"
                />
                <label for="ship-to">{{ $t('shop.checkout.ship_to_different_address') }}</label>
              </div>
            </div>
            <div class="row shipping-address" v-if="shipping.different">
              <div class="col-12">
                <h2>{{ $t('shop.checkout.shipping_address') }}</h2>
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    name="shipping_first_name"
                    :placeholder="$t('shop.checkout.first_name')"
                    v-model="shipping.first_name"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    name="shipping_last_name"
                    :placeholder="$t('shop.checkout.last_name')"
                    v-model="shipping.last_name"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input type="hidden" v-model="shipping.country" @change="reset_state('shipping')"
                       v-validate="'required'"/>
                <dropdown
                    :items="page.data.countries"
                    v-model="shipping.country"
                ></dropdown>
              </div>
              <div class="col-6 col-md-12">
                <input type="hidden" v-model="shipping.state" v-validate="'required'"/>
                <dropdown
                    v-if="states.shipping"
                    :items="states.shipping"
                    v-model="shipping_state"
                ></dropdown>
                <input
                    type="text"
                    v-else
                    :placeholder="$t('shop.checkout.state')"
                    v-model="shipping.state"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input type="text" name="shipping_city" :placeholder="$t('shop.checkout.city')" v-model="shipping.city"
                       @change="change"/>
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    name="shipping_address"
                    :placeholder="$t('shop.checkout.address')"
                    v-model="shipping.address_1"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input
                    type="text"
                    name="shipping_zip_code"
                    :placeholder="$t('shop.checkout.zip')"
                    v-model="shipping.zip_code"
                    @change="change"
                />
              </div>
              <div class="col-6 col-md-12">
                <input type="text" name="shipping_phone" :placeholder="$t('shop.checkout.phone')"
                       v-model="shipping.phone" @change="change"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 col-md-12">
          <Summary :loading="load_methods" :shipping_method="shipping_method"></Summary>
          <shipping-method v-model="shipping_method" :methods="shipping_methods"
                           :loading="load_methods"></shipping-method>
          <payment-method v-model="payment_method" :methods="payment_methods" :loading="load_methods"></payment-method>

          <!--<div class="cart-widget">-->
          <!--<div class="widget-header">-->
          <!--Shipping Method-->
          <!--</div>-->
          <!--<div class="widget-content">-->
          <!--<dl>-->
          <!--<dt>Onex:</dt>-->
          <!--<dd>4000 AMD</dd>-->
          <!--</dl>-->
          <!--</div>-->
          <!--</div>-->

          <!--<div class="cart-widget">-->
          <!--<div class="widget-header">-->
          <!--Payment method-->
          <!--</div>-->
          <!--<div class="widget-content">-->
          <!--<dl>-->
          <!--<dt>Onex:</dt>-->
          <!--<dd>4000 AMD</dd>-->
          <!--</dl>-->
          <!--</div>-->
          <!--</div>-->

          <div class="checkout-action-btn">
            <button
                class="button"
                :class="{loading: loading}"
                @click="checkoutProcess()"
            >{{ $t('shop.checkout.checkout') }}
            </button>
            <router-link :to="{name: 'static', params: {page: 'return-terms'}}">{{ $t('shop.checkout.return_terms') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service';
import Dropdown from '@/components/global/Dropdown.vue';
import Summary from '@/components/shop/cart/Summary.vue';
import PaymentMethod from '@/components/shop/cart/PaymentMethod.vue';
import ShippingMethod from '@/components/shop/cart/ShippingMethod.vue';
import { mapState } from 'vuex';

export default {
  name: 'checkout',
  components: {
    Dropdown,
    Summary,
    PaymentMethod,
    ShippingMethod
  },
  data () {
    return {
      billing_country: {
        name: this.$t('shop.checkout.country')
      },
      billing_state: {
        name: this.$t('shop.checkout.state')
      },
      shipping_country: {
        name: this.$t('shop.checkout.country')
      },
      shipping_state: {
        name: this.$t('shop.checkout.state')
      },
      billing: {
        country: '',
        state: ''
      },
      shipping: {
        address_1: '',
        different: false,
        country: '',
        state: ''
      },
      states: {
        billing: false,
        shipping: false
      },
      notification: false,
      notification_timeout: null,
      notification_type: null,
      payment_method: {},
      shipping_method: {},
      payment_methods: [],
      shipping_methods: [],
      loading: false,
      load_methods: false,
      cart_errors: false
    };
  },
  created () {
    if (this.$store.state.cart.items.length === 0) {
      this.$router.push({ name: 'cart' });
    }
    this.billing = this.checkout.billing;
    this.shipping = this.checkout.shipping;
  },
  methods: {
    notify (notification, type = 'success', time = 2500) {
      var self = this;
      self.notification = notification;
      self.notification_type = type;
      clearTimeout(this.notification_timeout);
      self.notification_timeout = setTimeout(function () {
        self.notification = false;
      }, time);
    },
    change () {
      this.$store.dispatch('fetchBillingAddress', this.billing);
      this.$store.dispatch('fetchShippingAddress', this.shipping);
    },
    reset_state (type) {
      if (type === 'billing') {
        this.billing.state = '';
        this.states.blling = false;
      } else if (type === 'shipping') {
        this.shipping.state = '';
        this.states.shipping = false;
      }
    },
    // eslint-disable-next-line camelcase
    updateProductStocks (updated_items) {
      var msg = [];
      // eslint-disable-next-line camelcase
      for (var key in updated_items) {
        if (updated_items[key].qty === 0) {
          this.$store.dispatch('removeCartItemQty', updated_items[key]);
          msg.push({
            name: updated_items[key].name,
            id: updated_items[key].item_id,
            msg: 'արդեն առկա չէ'
          });
        } else {
          this.$store.dispatch('fetchCartItemQty', updated_items[key]);
          msg.push({
            name: updated_items[key].name,
            id: updated_items[key].item_id,
            msg: 'այս պահին տվյալ քանակով առկա չէ'
          });
        }
      }
      this.cart_errors = msg;
      if (this.$store.state.cart.count === 0) {
        this.$store.dispatch('fetchNotification', {
          title: 'products_not_exists_now_title',
          content: 'products_not_exists_now_content'
        });
        this.$router.push({ name: 'notify', params: { lang: this.$i18n.locale } });
      }
    },
    checkoutProcess () {
      var t = this;
      this.$validator.validateAll().then(result => {
        this.cart_errors = false;
        if (result) {
          // console.log(this.coupon);
          t.loading = true;
          Api.post('checkout', {
            billing: this.billing,
            shipping: this.shipping,
            cart_items: this.cart,
            currency_id: 2,
            payment_method: this.payment_method,
            shipping_method: this.shipping_method,
            coupon: this.checkout.coupon,
            user_id: this.$store.state.auth.is_auth ? this.$store.state.auth.user.id : false
          })
            .then(response => {
              if (typeof response.data === 'string') {
                response.data = JSON.parse(response.data);
              }
              t.loading = false;
              if (response.data.status === 'error') {
                this.updateProductStocks(response.data.updated_products);
              } else if (response.data.grand_total === 0) {
                this.$store.dispatch('fetchCoupon', {
                  name: '',
                  msg: false,
                  coupon_amount: 0,
                  discount_type: '',
                  disabled: true
                });
                this.$router.push({
                  name: 'thankyou',
                  params: { lang: this.$i18n.locale },
                  query: {
                    invoice_no: response.data.order.invoice_no,
                    status: response.data.status
                  }
                });
                this.$store.dispatch('emptyCart');
              } else if (this.payment_method.key === 'cash') {
                this.$store.dispatch('fetchCoupon', {
                  name: '',
                  msg: false,
                  coupon_amount: 0,
                  discount_type: '',
                  disabled: true
                });
                this.$router.push({
                  name: 'thankyou',
                  params: { lang: this.$i18n.locale },
                  query: {
                    invoice_no: response.data.order.invoice_no,
                    status: response.data.status
                  }
                });
                this.$store.dispatch('emptyCart');
              } else if (this.payment_method.key === 'credit-card') {
                window.location.href = response.data.payment_response.payment_url;
              } else if (this.payment_method.key === 'idram') {
                document.getElementById('EDP_BILL_NO').value = response.data.order.invoice_no;
                document.getElementById('EDP_DESCRIPTION').value = 'Order #' + response.data.order.invoice_no;
                document.getElementById('redirect_to_idram').submit();
              }
            })
            .catch(error => {
              t.loading = false;
              // eslint-disable-next-line eqeqeq
              if (error.response.status === 419) {
                this.notify('ERROR! Please wait. Page reloading.', 'error');
                window.location.href = '/sign-in';
              } else {
                this.notify(this.$t('shop.checkout.errors.check_fields'), 'error');
                for (var key in error.response.data) {
                  this.errors.add({
                    field: key,
                    msg: error.response.data[key][0]
                  });
                  this.$validator.flag(key, {
                    invalid: true
                  });
                }
              }
            });
        } else {
          // console.log(this.errors);
          this.notify(this.$t('shop.checkout.errors.check_fields'), 'error');
        }
      });
    },
    // eslint-disable-next-line camelcase
    get_states_by_country (country_id) {
      var country = this.page.data.countries.filter(function (country) {
        // eslint-disable-next-line camelcase,eqeqeq
        return country.id === country_id;
      });
      return country[0].states;
    },
    // eslint-disable-next-line camelcase
    changeCountry (country_type) {
      this.load_methods = true;
      Api.post('/get-checkout-methods', {
        country: this[country_type].country.id,
        state: this[country_type].state.id
      })
        .then(response => {
          let jsonData = response.data;
          this.load_methods = false;
          this.payment_methods = jsonData.payment_methods;
          this.shipping_methods = jsonData.shipping_methods;
          this.payment_method = this.payment_methods[0];
          this.shipping_method = this.shipping_methods[0];
          this.states[country_type] = jsonData.states;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // eslint-disable-next-line camelcase
    loadStates (country_type) {
      Api.post('/load-states', {
        country: this[country_type].country.id,
        state: this[country_type].state.id
      })
        .then(response => {
          this.states[country_type] = response.data.states;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  beforeMount () {
    this.$store.dispatch('fetchPage', {
      countries: []
    });
  },
  computed: {
    ...mapState(['page', 'checkout', 'cart'])
  },
  watch: {
    'page.data' (to, from) {
      if (to.countries.length > 0 && !this.billing.country.id) {
        this.billing.country = this.page.data.default_country;
        this.shipping.country = this.page.data.default_country;
      }
    },
    'billing.country' (to, from) {
      // this.reset_state('billing')
      if (!this.shipping.different) {
        this.changeCountry('billing');
      } else {
        this.loadStates('billing');
      }
      this.change();
    },
    'shipping.country' (to, from) {
      // this.reset_state('shipping')
      if (this.shipping.different) {
        this.changeCountry('shipping');
      } else {
        this.loadStates('shipping');
      }
      this.change();
    },
    'billing_state' (to, from) {
      this.billing.state = to.name;
      this.change();
    },
    'shipping_state' (to, from) {
      this.shipping.state = to.name;
      this.change();
    }
  }
};
</script>

<style lang="scss">
.checkout {
  padding-top: 130px;

  @include mq($ms) {
    padding-top: 90px;
  }

  .checkout-form {
    h2 {
      margin-top: 0;
      margin-bottom: 15px;
      font-family: $font-bold;
    }

    input,
    textarea {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      outline: none;
      height: 45px;
      border: 1px solid #ccc;
      padding: 0 15px;
      font-size: 16px;

      &[aria-invalid="true"] {
        border: 1px solid red;
        @include placeholder-color(red);
      }

      &[type="hidden"] {
        &[aria-invalid="true"] {
          & + input {
            border: 1px solid red;
            @include placeholder-color(red);
          }

          & + .dropdown {
            span {
              border: 1px solid red;
              color: red;
            }
          }
        }
      }

      @include placeholder {
        font-size: 16px;
        font-family: $font-regular;
      }
    }

    textarea {
      min-height: 100px;
      max-height: 300px;
      padding-top: 15px;
    }

    .shipping-address {
      margin-top: 15px;
    }
  }

  .cart-errors {
    margin-bottom: 30px;
    color: red;

    a {
      text-decoration: underline;
    }
  }
}
</style>
